import React, { PropsWithChildren } from 'react';
import { Row, Col } from 'antd';
import { Icon } from '@common/components';

export function CandidateOfferCardItem({ children }: PropsWithChildren) {
  return (
    <Row gutter={[8, 8]}>
      <Col>
        <Icon icon="fileSearch" kind="light" />
      </Col>
      <Col>{children}</Col>
    </Row>
  );
}
